<!--TODO temporary. will be refactored-->

<cmps-wait-status *ngIf="pendingInit"></cmps-wait-status>
<ng-container *ngIf="!pendingInit">
    <div class="su-selection">
        <div class="d-flex align-items-center">
            <span class="mr-1"
                >{{ _i18n._9736_INDIVIDUAL_SELECTED | translate }}:</span
            >
            <button
                class="btn bg-transparent d-inline-flex p-0"
                (click)="_onToggleFavoriteClick(selectedUser)"
                *ngIf="selectedUser"
            >
                <cmps-icon
                    class="cmps-cdk-pr-0dot25"
                    [class.cmps-cdk-fill-grey-300]="!selectedUser?.favourite"
                    [class.cmps-cdk-fill-yellow-100]="selectedUser?.favourite"
                    svgIcon="star"
                ></cmps-icon>
                <span class="su-active su-font-lg">{{
                    selectedUser?.userName || (_i18n._1_NONE | translate)
                }}</span>
            </button>
            <span
                class="su-active su-font-lg"
                *ngIf="!selectedUser"
                >{{ _i18n._1_NONE | translate }}</span
            >
        </div>
        <div *ngIf="hasSelfButton">
            <button
                class="cmps-outline-button--sm cmps-outline-button--no-bg"
                cmpsOutlineButton
                (click)="_onSelfClick()"
            >
                <span cmpsOutlineButtonLabel>{{
                    _i18n._7409_DEFAULT_VIEW__SELF_ | translate
                }}</span>
                <cmps-icon svgIcon="check-bold"></cmps-icon>
            </button>
        </div>
        <div>
            <span class="mr-1">{{ _i18n._48_MANAGER | translate }}:</span>
            <span
                class="su-primary su-pointer"
                tabindex="-1"
                role="button"
                (click)="_onUserClick(selectedUserManager.userId)"
                *ngIf="selectedUserManager"
            >
                {{ selectedUserManager?.userName }}
            </span>
            <span
                class="su-primary"
                *ngIf="!selectedUserManager"
            >
                {{ _i18n._1_NONE | translate }}
            </span>
        </div>
    </div>
    <div class="su-separator"></div>
    <div class="su-team-favorites">
        <div class="su-team">
            <cmps-wait-status
                class="m-auto"
                *ngIf="pendingSelectUser"
            ></cmps-wait-status>
            <div
                class="mt-3 mr-auto ml-auto w-75 text-center"
                *ngIf="!pendingSelectUser && !teamRows?.length"
            >
                {{ _i18n._94_NO_RESULTS | translate }}
            </div>
            <div
                ngGrid
                [ngClass]="{ 'd-none': pendingSelectUser || !teamRows?.length }"
                [rendererOptions]="_teamGridRenderOpts"
                [selectTemplate]="_gridSelectTpl"
                (inflate)="_onTeamGridInflate()"
                #teamGrid="grid"
            >
                <ng-template
                    gridContent
                    data-type="grid"
                >
                    <div></div>
                </ng-template>

                <ng-template
                    gridContent
                    data-type="row"
                >
                    <div></div>
                </ng-template>

                <ng-template
                    gridContent
                    data-type="cell"
                    let-c="c"
                    let-ctx="ctx"
                >
                    <!--must have single root-->
                    <div [ngSwitch]="c.id">
                        <div *ngSwitchCase="_ColumnID.NAME">
                            <button
                                class="btn bg-transparent mr-1 p-1"
                                (click)="_onToggleFavoriteClick(ctx)"
                            >
                                <cmps-icon
                                    [class.cmps-cdk-fill-grey-300]="
                                        !ctx.favourite
                                    "
                                    [class.cmps-cdk-fill-yellow-100]="
                                        ctx.favourite
                                    "
                                    svgIcon="star"
                                ></cmps-icon>
                            </button>
                            <div
                                class="su-pointer"
                                [ngClass]="{
                                    'su-active':
                                        ctx.userId ===
                                        selectedUserManager?.userId
                                }"
                                tabindex="-1"
                                role="button"
                                (click)="_onUserClick(ctx.userId)"
                            >
                                {{ ctx.userName }}
                            </div>
                        </div>
                    </div>
                </ng-template>

                <ng-template
                    gridContent
                    data-type="cell"
                    data-id="header"
                >
                    <div>
                        <div>
                            <cmps-icon
                                class="cmps-cdk-mr-0dot25"
                                svgIcon="badge-account"
                            ></cmps-icon>
                            <span>{{
                                _i18n._9740_DIRECT_REPORTS | translate
                            }}</span>
                        </div>
                    </div>
                </ng-template>
            </div>
        </div>
        <div
            ngGrid
            class="su-favorites"
            [rendererOptions]="_favoritesGridRenderOpts"
            [selectTemplate]="_gridSelectTpl"
            (inflate)="_onFavoritesGridInflate()"
            #favoritesGrid="grid"
        >
            <ng-template
                gridContent
                data-type="grid"
            >
                <div></div>
            </ng-template>

            <ng-template
                gridContent
                data-type="row"
            >
                <div></div>
            </ng-template>

            <ng-template
                gridContent
                data-type="cell"
                let-c="c"
                let-ctx="ctx"
            >
                <!--must have single root-->
                <div [ngSwitch]="c.id">
                    <div *ngSwitchCase="_ColumnID.NAME">
                        <button
                            class="btn bg-transparent mr-1 p-1"
                            (click)="_onToggleFavoriteClick(ctx)"
                        >
                            <cmps-icon
                                [class.cmps-cdk-fill-grey-300]="!ctx.favourite"
                                [class.cmps-cdk-fill-yellow-100]="ctx.favourite"
                                svgIcon="star"
                            ></cmps-icon>
                        </button>
                        <cmps-wait-status
                            *ngIf="pendingSelectUser"
                        ></cmps-wait-status>
                        <div
                            class="su-pointer"
                            tabindex="-1"
                            role="button"
                            (click)="_onUserClick(ctx.userId)"
                        >
                            {{ ctx.userName }}
                        </div>
                    </div>
                </div>
            </ng-template>

            <ng-template
                gridContent
                data-type="cell"
                data-id="header"
            >
                <div>
                    <div class="m-auto">
                        <cmps-icon
                            class="cmps-cdk-mr-0dot25"
                            svgIcon="star"
                        ></cmps-icon>
                        <span>{{
                            _i18n._9737_YOUR_FAVOURITES | translate
                        }}</span>
                    </div>
                </div>
            </ng-template>
        </div>
    </div>
    <div class="su-separator"></div>
    <div
        class="su-body"
        role="form"
        [formGroup]="form"
        (keyup.enter)="_onSearchClick($event)"
    >
        <div>
            <div class="d-inline-flex mt-3 mb-3">
                <div class="custom-control custom-radio pr-3">
                    <input
                        type="radio"
                        class="custom-control-input"
                        [id]="'status' + _StatusType.ACTIVE"
                        [value]="_StatusType.ACTIVE"
                        formControlName="statusType"
                    />
                    <label
                        class="custom-control-label"
                        [for]="'status' + _StatusType.ACTIVE"
                    >
                        {{ _i18n._7154_ACTIVE_USERS | translate }}
                    </label>
                </div>
                <div class="custom-control custom-radio pr-3">
                    <input
                        type="radio"
                        class="custom-control-input"
                        [id]="'status' + _StatusType.INACTIVE"
                        [value]="_StatusType.INACTIVE"
                        formControlName="statusType"
                    />
                    <label
                        class="custom-control-label"
                        [for]="'status' + _StatusType.INACTIVE"
                    >
                        {{ _i18n._7155_DEACTIVE_USERS | translate }}
                    </label>
                </div>
                <div class="custom-control custom-radio pr-3">
                    <input
                        type="radio"
                        class="custom-control-input"
                        [id]="'status' + _StatusType.BOTH"
                        [value]="_StatusType.BOTH"
                        formControlName="statusType"
                    />
                    <label
                        class="custom-control-label"
                        [for]="'status' + _StatusType.BOTH"
                    >
                        {{ _i18n._7156_ALL_USERS | translate }}
                    </label>
                </div>
            </div>
            <div formArrayName="parameters">
                <ng-container
                    *ngFor="let control of _parameters()?.controls; index as i"
                >
                    <div
                        class="form-group su-param-row"
                        [formGroupName]="i"
                    >
                        <div class="su-param-col su-param-col-which">
                            <ng-select
                                [options]="parameterOpts"
                                [id]="'param-' + i"
                                formControlName="parameterType"
                            ></ng-select>
                        </div>
                        <div class="su-param-col su-param-col-input">
                            <div
                                class="d-flex align-items-center justify-content-between w-100"
                            >
                                <label
                                    class="mb-0 pr-3"
                                    [for]="'param-value-' + i"
                                >
                                    {{ _i18n._7157_INCLUDES | translate }}
                                </label>
                                <ng-container
                                    [ngSwitch]="
                                        _parameterTypeConfig(i)?.inputType
                                    "
                                >
                                    <input
                                        *ngSwitchCase="_InputType.TEXTBOX"
                                        type="text"
                                        class="form-control"
                                        [id]="'param-value-' + i"
                                        formControlName="value"
                                    />
                                    <ng-select
                                        *ngSwitchCase="_InputType.DROPDOWN"
                                        [options]="
                                            parameterLookupOpts[
                                                _parameterTypeConfig(i)
                                                    ?.parameterType
                                            ]
                                        "
                                        [placeholder]="
                                            _parameterTypeConfig(i)?.placeholder
                                                | translate
                                        "
                                        [id]="'param-state-' + i"
                                        formControlName="value"
                                    ></ng-select>
                                </ng-container>
                            </div>
                        </div>
                        <div
                            class="su-param-col su-param-col-status"
                            *ngIf="
                                _parameterTypeConfig(i)?.hasStatus &&
                                form.get('statusType').value !==
                                    _StatusType.INACTIVE
                            "
                        >
                            <div
                                class="d-flex align-items-center justify-content-between w-100"
                            >
                                <label
                                    class="mb-0 pr-3"
                                    [for]="'param-state-' + i"
                                >
                                    {{
                                        _parameterTypeConfig(i)?.statusLabel ||
                                            _parameterTypeConfig(i)?.label
                                            | translate
                                    }}
                                    {{ _i18n._127_STATUS | translate }}</label
                                >
                                <ng-select
                                    [options]="statusOpts"
                                    [noFilter]="999"
                                    [placeholder]="'&nbsp;'"
                                    [id]="'param-state-' + i"
                                    formControlName="status"
                                ></ng-select>
                            </div>
                        </div>
                        <div
                            class="su-param-col su-param-col-remove"
                            *ngIf="_parameters()?.length > 1"
                        >
                            <button
                                type="button"
                                class="btn bg-transparent pr-0 pl-0"
                                (click)="_onRemoveParameterClick(i)"
                            >
                                <cmps-icon
                                    svgIcon="close-circle-outline"
                                ></cmps-icon>
                                {{ _i18n._7158_REMOVE | translate }}
                            </button>
                        </div>
                    </div>
                </ng-container>
            </div>
        </div>
        <div
            class="d-flex align-items-center justify-content-between"
            [ngClass]="{ 'mb-3': pendingSearch || didInitialSearch }"
        >
            <div>
                <button
                    type="button"
                    class="btn btn-primary"
                    (click)="_onAddParameterClick()"
                    *ngIf="_parameters()?.length < parameterOpts.length"
                >
                    {{ _i18n._7159_ADD_PARAMETERS | translate }}
                </button>
            </div>
            <div>
                <button
                    type="submit"
                    class="btn btn-primary"
                    (click)="_onSearchClick($event)"
                >
                    <cmps-icon svgIcon="magnify"></cmps-icon>
                    {{ _i18n._710_SEARCH | translate }}
                </button>
                <button
                    type="button"
                    class="btn btn-primary"
                    (click)="_onClearClick()"
                >
                    {{ _i18n._9738_CLEAR_ALL | translate }}
                </button>
            </div>
        </div>
    </div>
    <div
        class="su-separator"
        *ngIf="!pendingSearch && searchRows?.length"
    ></div>
    <div class="mb-3 su-results">
        <cmps-wait-status
            [status]="_i18n._818_FETCHING_YOUR_DATA__PLEASE_WAIT_ | translate"
            *ngIf="pendingSearch"
        ></cmps-wait-status>
        <div
            class="mt-3 mr-auto ml-auto w-75 text-center"
            *ngIf="
                !pendingSearch &&
                didInitialSearch &&
                !searchFailed &&
                !searchRows?.length
            "
        >
            {{
                _i18n._7161_NO_USERS_WERE_FOUND__PLEASE_MODIFY_YOUR_SEARCH_CRITERIA_AND_TRY_AGAIN__IF_YOU_CONTINUE_EXPERIENCING_PROBLEMS__IT_COULD_BE_DUE_TO_PERMISSIONS_OR_INCORRECT_USER_CONFIGURATION___PLEASE_CONTACT_YOUR_SYSTEM_ADMINISTRATOR_
                    | translate
            }}
        </div>
        <div
            class="mt-3 mr-auto ml-auto w-75 text-center"
            *ngIf="!pendingSearch && didInitialSearch && searchFailed"
        >
            {{
                _i18n._935_AN_ERROR_OCCURRED_WHILE_PROCESSING_YOUR_SEARCH__PLEASE_TRY_AGAIN_
                    | translate
            }}
        </div>
        <div
            ngGrid
            [ngClass]="{ 'd-none': pendingSearch || !searchRows?.length }"
            [rendererOptions]="_searchGridRenderOpts"
            [selectTemplate]="_gridSelectTpl"
            (inflate)="_onSearchGridInflate()"
            #searchGrid="grid"
        >
            <ng-template
                gridContent
                data-type="grid"
            >
                <div></div>
            </ng-template>

            <ng-template
                gridContent
                data-type="row"
            >
                <div></div>
            </ng-template>

            <ng-template
                gridContent
                data-type="cell"
                let-c="c"
                let-ctx="ctx"
            >
                <!--must have single root-->
                <div [ngSwitch]="c.id">
                    <div
                        *ngSwitchCase="_ColumnID.NAME"
                        class="su-pointer"
                        (click)="_onUserClick(ctx.userId)"
                    >
                        {{ ctx.userName }}
                    </div>
                    <div *ngSwitchCase="_ColumnID.SITE">
                        {{ ctx.site }}
                    </div>
                    <div *ngSwitchCase="_ColumnID.ROLE">
                        {{ ctx.role }}
                    </div>
                    <div *ngSwitchCase="_ColumnID.SUPER_GROUP">
                        {{ ctx.superGroup }}
                    </div>
                    <div
                        *ngSwitchCase="_ColumnID.MANGER_NAME"
                        class="su-pointer"
                        (click)="_onUserClick(ctx.managerId)"
                    >
                        {{ ctx.managerName }}
                    </div>
                    <div *ngSwitchCase="_ColumnID.STATUS">
                        {{
                            (ctx.active
                                ? _i18n._125_ACTIVE
                                : _i18n._126_DEACTIVE
                            ) | translate
                        }}
                    </div>
                </div>
            </ng-template>

            <ng-template
                gridContent
                data-type="cell"
                data-id="header"
                let-c="c"
                let-ctx="ctx"
            >
                <div>
                    <div class="d-flex align-items-center w-100">
                        <button
                            class="btn bg-transparent p-0 d-flex align-items-center justify-content-between w-100"
                            (click)="_onSortClick(c)"
                        >
                            <span class="ml-2 mr-1">{{ ctx | translate }}</span>
                            <cmps-icon
                                [svgIcon]="
                                    searchSortDefs[0].order === _SortOrder.ASC
                                        ? 'chevron-up'
                                        : 'chevron-down'
                                "
                                *ngIf="
                                    searchSortDefs &&
                                    searchSortDefs.length &&
                                    searchSortDefs[0].columnId === c.id
                                "
                            ></cmps-icon>
                            <cmps-icon
                                svgIcon="unfold-more-horizontal"
                                *ngIf="
                                    !searchSortDefs ||
                                    !searchSortDefs.length ||
                                    searchSortDefs[0].columnId !== c.id
                                "
                            ></cmps-icon>
                        </button>
                    </div>
                </div>
            </ng-template>
        </div>
        <div
            class="mt-3 mr-auto ml-auto w-75 text-center"
            *ngIf="!pendingSearch && didInitialSearch && searchExceedsMaxCount"
        >
            {{
                _i18n._938_THESE_SEARCH_CRITERIA_RESULTED_IN_MORE_THAN_THE_50_RECORDS_DISPLAYED_HERE__PLEASE_NARROW_YOUR_CRITERIA_AND_SEARCH_AGAIN_IF_YOU_DO_NOT_SEE_THE_RECORD_YOU_ARE_LOOKING_FOR_
                    | translate
            }}
        </div>
    </div>
    <div class="d-flex justify-content-center">
        <button
            class="btn btn-primary"
            (click)="_onSelectClick()"
        >
            {{ _i18n._9739_FINISH_USER_SELECTION | translate }}
        </button>
    </div>
</ng-container>
